module.exports = __webpack_public_path__ + "img/img2.b0f8cc50.jpg";